export const  FileUploadRoutes = {
    FileUpload: "/app/uploadFiles",
    
  };
    